import BtnDelete from './BtnDelete'

export default {
  BtnDelete
}
